<template>
  <education-details v-if="!loading && education.model_type === 'education'" :education="education" />
  <education-masters-details
    v-else-if="!loading && education.model_type === 'education-masters'"
    :education="education"
  />
</template>
<script>
import EducationDetails from '@/pages/frontend/education/EducationDetails';
import EducationMastersDetails from '@/pages/frontend/education/EducationMastersDetails';

export default {
  name: 'educations-router',
  components: { EducationDetails, EducationMastersDetails },
  data() {
    return {
      education: null,
      loading: true,
    };
  },
  mounted() {
    this.$bus.$emit('loading', true);

    this.getEducation(this.$route.params.slug)
      .then(({ data }) => {
        this.education = data;
        this.education.scholarships_json = Array.isArray(data.scholarships_json) ? data.scholarships_json : [];
        this.loading = false;
        this.$bus.$emit('hasRecordingVideo', Boolean(this.education.recording_video));

        if (data.model_type === 'education') {
          this.$router
            .replace({
              name: 'education-detail',
              params: { slug: data.slug, education: data },
            })
            .catch((err) => {
              if (err.name !== 'NavigationDuplicated') {
                return Promise.reject(err);
              }
            });
        }

        if (data.model_type === 'education-masters' && data.degree_type === 'masters') {
          this.$router
            .replace({
              name: 'education-degree-masters-detail',
              params: { slug: data.slug, education: data },
            })
            .catch((err) => {
              if (err.name !== 'NavigationDuplicated') {
                return Promise.reject(err);
              }
            });
        }

        if (data.model_type === 'education-masters' && data.degree_type === 'phd') {
          this.$router
            .replace({
              name: 'education-degree-phd-detail',
              params: { slug: data.slug, education: data },
            })
            .catch((err) => {
              if (err.name !== 'NavigationDuplicated') {
                return Promise.reject(err);
              }
            });
        }
      })
      .catch((e) => {
        if (e.response.status === 404) {
          this.$router.push('/404');
        }
      })
      .finally(() => {
        this.$bus.$emit('loading', false);
      });
  },
  methods: {
    getEducation(slug) {
      const excludes = [
        'media',
        'versions',
        'creator',
        'data',
        'prices',
        'dates',
        'members',
        'banner_image',
        'tile_image',
        'promo_images',
        'result_images',
      ];

      return window.axios.get(`/api/all-educations/${slug}?excludes=${excludes.join(',')}`);
    },
  },
};
</script>
